import { render, staticRenderFns } from "./AddJcomOnlinePayment.vue?vue&type=template&id=e61f5e24&scoped=true"
import script from "./AddJcomOnlinePayment.vue?vue&type=script&lang=js"
export * from "./AddJcomOnlinePayment.vue?vue&type=script&lang=js"
import style0 from "./AddJcomOnlinePayment.vue?vue&type=style&index=0&id=e61f5e24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61f5e24",
  null
  
)

export default component.exports